<div class="product-details-panel" [class.open]="isDetailsVisible">
  <div class="panel-header">
    <ui-button type="secondary" icon="close" iconSize="large" (click)="closeDetails()"></ui-button>
    <span class="title">{{ 'product.dialog.details.title' | translate }}</span>
  </div>

  <!-- Dialog content -->
  <div class="content" *ngIf="selectedProduct">
    <div class="section">
      <!-- Product name -->
      <div class="product-name">
        {{ selectedProduct.name }}
      </div>
  
      <!-- General information -->

      <!-- Brand -->
      <div class="detail-row">
        <div class="detail-label">{{ 'product.dialog.details.brand' | translate }}</div>
        <div class="detail-value">{{ selectedProduct.brand?.name || '--' }}</div>
      </div>

      <!-- Description -->
      <div class="detail-row description-row">
        <div class="detail-label">{{ 'product.dialog.details.description' | translate }}</div>
        <div class="detail-value">
          <div class="description-text" [class.expanded]="isDescriptionExpanded"
            [innerHTML]="selectedProduct.description || '--'">
          </div>
          <button *ngIf="shouldShowToggle" class="show-more-btn" (click)="toggleDescription()">
            {{ isDescriptionExpanded ? 'product.dialog.actions.show_less' : 'product.dialog.actions.show_more' | translate }}
          </button>
        </div>
      </div>
  
      <!-- EAN -->
      <div class="detail-row">
        <div class="detail-label">{{ 'product.dialog.details.ean' | translate }}</div>
        <div class="detail-value">{{ selectedProduct.barcode || '--' }}</div>
      </div>
  
      <!-- SKU -->
      <div class="detail-row">
        <div class="detail-label">{{ 'product.dialog.details.sku' | translate }}</div>
        <div class="detail-value">{{ selectedProduct.sku || '--' }}</div>
      </div>
  
      <!-- Custom Fields -->
      <!-- TODO: Add custom fields -->
  
      <!-- Go to product -->
      <div class="go-to-product">
        <button class="go-to-btn" (click)="goToProduct()">
          <span>{{ 'product.dialog.actions.view_product' | translate }}</span>
          <img src="assets/icones/arrow-link.svg" alt="arrow link" class="arrow-icon" />
        </button>
      </div>
    </div>

    <!-- Available Pricebook rules -->
    <div class="section" *ngIf="featureFlags.loyaltyEnabled">
      <div class="section-title">{{ 'product.dialog.sections.available_pricebook_rules' | translate }}</div>
        <div class="detail-row" *ngFor="let gift of getProductGifts()">
          <span class="detail-value">
            <img src="assets/icones/reward.svg" alt="gift" srcset="" />
            {{ gift.name }}
          </span>
        </div>
        <div class="detail-label" *ngIf="getProductGifts().length === 0">{{ 'product.dialog.no_data.no_pricebook_rules' | translate }}</div>
    </div>

    <div class="handling-units-section" *ngIf="shouldShowHandlingUnitsSection()">
      <div class="handling-unit-header">
        <div class="header">
          <div class="title-medium">{{ 'Catalogs.product_details.enabled_handling_units' | translate }}</div>
          <img 
            class="image" 
            width="20px" 
            src="assets/icones/info-cc.svg" 
            alt=""
            [matTooltip]="'Catalogs.product_details.enabled_handling_units_info' | translate"
            matTooltipPosition="right"
            style="cursor: pointer;">
        </div>
      </div>
      
      <!-- Mode EDIT: Afficher les selects -->
      <div class="standard-input" *ngIf="context === 'catalog-edit'">
        <mat-select [(ngModel)]="selectedEnabledHandlingUnits" [disabled]="!canSubmit" multiple class="custom-select" (selectionChange)="onEnabledHandlingUnitsChange()">
          <mat-select-trigger class="tags-container">
             <ng-container *ngIf="getSelectedEnabledHandlingUnits().length > 0">
              <span class="tag" *ngFor="let unit of getSelectedEnabledHandlingUnits()">{{ unit.name }}</span>
            </ng-container>
          </mat-select-trigger>
          <mat-option *ngFor="let unit of getDisplayedHandlingUnitsForSelect()" [value]="unit.id">
            <div class="option-content">
              <span class="tag">{{ unit.name }}</span>
              <span class="quantity">{{ unit.quantity }} {{ 'Catalogs.product_details.handling_units' | translate }}</span>
            </div>
          </mat-option>
            <span *ngIf="getDisplayedHandlingUnitsForSelect().length === 0" style="color: #999;">--</span>
        </mat-select>
      </div>

      <!-- Mode VIEW: Afficher les tags -->
      <div class="detail-value" *ngIf="context === 'catalog-view'">
        <ng-container *ngIf="getSelectedEnabledHandlingUnits().length > 0; else noEnabledHUs">
          <span class="chip gray-chip" *ngFor="let unit of getSelectedEnabledHandlingUnits()">
            {{ unit.name }}
          </span>
        </ng-container>
        <ng-template #noEnabledHUs>
          <span class="text-muted">--</span>
        </ng-template>
      </div>

      <div class="handling-unit-header">
        <div class="header">
          <div class="title-medium">{{ 'Catalogs.product_details.default_handling_unit' | translate }}</div>
          <img 
            class="image" 
            width="20px" 
            src="assets/icones/info-cc.svg" 
            alt=""
            [matTooltip]="'Catalogs.product_details.default_handling_unit_info' | translate"
            matTooltipPosition="right"
            style="cursor: pointer;">
        </div>
      </div>
      
      <!-- Mode EDIT: Afficher le select -->
      <div class="standard-input" *ngIf="context === 'catalog-edit'">
        <mat-select [(ngModel)]="selectedDefaultHandlingUnit" [disabled]="!canSubmit || !getSelectedEnabledHandlingUnits() || getSelectedEnabledHandlingUnits().length === 0" class="custom-select">
          <mat-select-trigger class="tags-container">
             <ng-container *ngIf="selectedDefaultHandlingUnit">
              <span class="tag">{{ getDefaultHandlingUnitDisplayLabel() }}</span>
            </ng-container>
          </mat-select-trigger>
            <mat-option *ngFor="let unit of getSelectedEnabledHandlingUnits()" [value]="unit.id">
              <div class="option-content">
                <span class="tag">{{ unit.name }}</span>
                <span class="quantity">{{ unit.quantity }} {{ 'Catalogs.product_details.handling_units' | translate }}</span>
              </div>
            </mat-option>
            <span *ngIf="!selectedDefaultHandlingUnit || getSelectedEnabledHandlingUnits().length === 0" style="color: #999;">--</span>
          </mat-select>
      </div>

      <!-- Mode VIEW: Afficher  le tag -->
      <div class="detail-value" *ngIf="context === 'catalog-view'">
        <ng-container *ngIf="selectedDefaultHandlingUnit && getDefaultHandlingUnitDisplayLabel(); else noDefaultHU">
          <span class="chip gray-chip">{{ getDefaultHandlingUnitDisplayLabel() }}</span>
        </ng-container>
        <ng-template #noDefaultHU>
          <span class="text-muted">--</span>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="panel-footer">
    <ui-button type="outlined-gay" label="{{ 'Catalogs.buttons.close' | translate | uppercase }}"
      (click)="closeDetails()"></ui-button>
  </div>
</div>
